@if (isUserRetrieved) {
  <div class="dialog__kopf">
    <h2 class="dialog__ueberschrift">Benutzer <strong>„{{ user.first_Name }} {{ user.last_Name }}“</strong></h2>
    @if (fensterGesperrt) {
      <span class="dialog__sperre" role="status"><mat-icon>lock_outline</mat-icon>{{ sperrText }}</span>
    } @else {
      <button type="button" class="dialog__schliessen" aria-label="Fenster schließen" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
}

<div class="dialog__inhalt">
  @if (isUserRetrieved && isTenantsRetrieved) {
    <confirm-user [user] = "user" [userTenants] = "userTenants"></confirm-user>
  }
</div>
